module.exports = __webpack_public_path__ + "img/Jc.5370b4ad.png";